import React from 'react';
import { TextField, MenuItem, Grid } from '@mui/material';

const PersonalInformation = ({ formData, setFormData }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Full Name"
          name="fullName"
          value={formData.fullName || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Date of Birth"
          type="date"
          name="dob"
          value={formData.dob || ''}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Gender"
          name="gender"
          value={formData.gender || ''}
          onChange={handleChange}
          select
        >
          <MenuItem value="Male">Male</MenuItem>
          <MenuItem value="Female">Female</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Contact Number"
          name="contactNumber"
          value={formData.contactNumber || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Email Address"
          name="email"
          value={formData.email || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="LinkedIn Profile"
          name="linkedin"
          value={formData.linkedin || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Current Location"
          name="currentLocation"
          value={formData.currentLocation || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Preferred Job Location(s)"
          name="preferredJobLocations"
          value={formData.preferredJobLocations || []} // Fallback to an array
          onChange={handleChange}
          select
          SelectProps={{ multiple: true }}
        >
          <MenuItem value="Mumbai">Mumbai</MenuItem>
          <MenuItem value="Delhi">Delhi</MenuItem>
          <MenuItem value="Bangalore">Bangalore</MenuItem>
          <MenuItem value="Hyderabad">Hyderabad</MenuItem>
          <MenuItem value="Chennai">Chennai</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Notice Period"
          name="noticePeriod"
          value={formData.noticePeriod || ''}
          onChange={handleChange}
          select
        >
          <MenuItem value="Immediate">Immediate</MenuItem>
          <MenuItem value="1 Month">1 Month</MenuItem>
          <MenuItem value="2 Months">2 Months</MenuItem>
          <MenuItem value="3 Months">3 Months</MenuItem>
        </TextField>
      </Grid>
    </Grid>
  );
};

export default PersonalInformation;